export default "__VITE_ASSET__fPIrVNvM__"